import VueObserveVisibility from 'vue-observe-visibility'

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.use(VueObserveVisibility)
})
